import { InteractionStatus } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { Loading } from 'app/components/Loading'
import { useAppDispatch, useAppSelector } from 'app/services/hooks/store-hooks'
import {
  isAuthRedirectInProgress,
  markAuthRedirectInProgress,
} from 'app/services/utils/authRedirect'
import { clearReauthRequirement } from 'app/store/slice/maintenanceSlice'
import { loginRequest } from 'authConfig'
import React, { useEffect } from 'react'

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { instance, inProgress } = useMsal()
  const dispatch = useAppDispatch()
  const isAuthenticated = useIsAuthenticated()
  const requiresReauth = useAppSelector(
    (state) => state.maintenance.requiresReauth
  )

  useEffect(() => {
    if (
      inProgress !== InteractionStatus.None ||
      !requiresReauth ||
      isAuthRedirectInProgress()
    ) {
      return
    }

    dispatch(clearReauthRequirement())
    markAuthRedirectInProgress()
    instance.loginRedirect(loginRequest)
  }, [dispatch, inProgress, instance, requiresReauth])

  useEffect(() => {
    if (
      inProgress === InteractionStatus.None &&
      !isAuthenticated &&
      !isAuthRedirectInProgress()
    ) {
      markAuthRedirectInProgress()
      instance.loginRedirect(loginRequest)
    }
  }, [inProgress, instance, isAuthenticated])

  if (inProgress !== InteractionStatus.None && !isAuthenticated) {
    return <Loading />
  }

  if (requiresReauth) {
    return <Loading />
  }

  if (!isAuthenticated) {
    return <Loading />
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

export default AuthGuard
